<template>
	<auth>
		<vForm v-bind="{loading, error}" @submit="reset">
			<vItem item="email" label="Email:" v-bind="error">
				<vInput id="email" type="text" v-model="form.email" placeholder="Indtast din e-mail" required/>
			</vItem>
			<vItem item="password" label="New password:" v-bind="error">
				<vInput id="password" type="password" v-model="form.password" placeholder="Indtast din adgangskode" required/>
			</vItem>
			<vItem item="password_confirmation" label="Confirm password:" v-bind="error">
				<vInput id="password_confirmation" type="password" v-model="form.password_confirmation" placeholder="Indtast din adgangskode" required/>
			</vItem>

			<vButton>Reset adgangskode</vButton>
		</vForm>
	</auth>
</template>

<script>
import {get} from "lodash";
import auth from "@/components/auth.vue";
import {vForm, vItem, vInput, vButton} from "@/components/form";

export default {
	components: {auth, vForm, vItem, vInput, vButton},
	data() {
		return {
			loading: false,
			error: {},

			form: {
				email: "",
				password: "",
				password_confirmation: ""
			}
		}
	},
	computed: {
		id: (t) => t.$route.params.id
	},
	methods: {
		async reset() {
			this.loading = true;

			try {
				await this.$axios.post("admin/password/reset", {...this.form, token: this.id}, {custom: true});
				this.$router.push({name: "login"});
			} catch(err) {
				this.error = get(err, "response.data", {});
			}

			this.loading = false;
		}
	}
};
</script>

<style lang="scss" scoped>
.forgot {
	display: block;
	text-align: center;
	margin-top: 2em;
	color: #007ACE;
	text-decoration: underline;
	font-size: 13px;
}
</style>
